﻿import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";

export class AnalyticsManager extends MonoBehaviour {

    SendVideoAdsAvailable(placement, isReady, isWaited) {
        this.SendEvent("video_ads_available", {placement, isReady, isWaited});
    }

    SendVideoAdsStarted(placement, isAdStarted) {
        this.SendEvent("video_ads_started", {placement, isAdStarted});
    }

    SendVideoAdsEvent(placement, result, object_id) {
        this.SendEvent("video_ads_watch", {placement, result, object_id});
    }

    SendVideoAdsLoaded(placement, sec) {
        this.SendEvent("video_ads_loaded", {placement, sec});
    }

    SendInterstitialNotReady(timesPerSession) {
        this.SendEvent("interstitial_ads_not_ready", {timesPerSession});
    }

    SendVideoAdsCancel(objectId) {
        objectId = objectId || "";
        this.SendEvent("video_ads_cancel", {objectId});
    }

    SendChestEvent(reason) {
        this.SendEvent("open_chest", {reason});
    }

    SendHardEvent(category, screen, item_id, value) {
        this.SendEvent("hard_currency", {category, screen, item_id, value});
    }

    SendSoftEvent(category, screen, item_id, value) {
        this.SendEvent("soft_currency", {category, screen, item_id, value});
    }

    SendPlanetUnlockEvent(planet_id) {
        this.SendEvent("planet_unlock", {planet_id});
    }

    SendMonsterUnlockEvent(monster_id, planet_id, monster_rank) {
        this.SendEvent("moster_unlock", {monster_id, planet_id, monster_rank});
    }

    SendEpochUnlockEvent(epoch_id, planet_id) {
        this.SendEvent( "level_unlock", {epoch_id, planet_id});
    }

    SendTutorialEvent(step) {
        this.SendEvent("tutorial", {step});
    }

    SendOfferEvent(offer_name, offer_price, offer_content, offer_duration, offer_purchase_time, offer_action) {
        this.SendEvent("offer", {offer_name, offer_price, offer_content, offer_duration, offer_purchase_time, offer_action});
    }

    SendUpgradeEvent(item_id, level, planet_id) {
        this.SendEvent("upgrade_purchse", {item_id, level, planet_id});
    }

    SendBoosterEvent(booster_id) {
        this.SendEvent("booster_purchase", {booster_id});
    }

    SendMonsterEvent(currency_name, value, monster_id, planet_id, monster_rank) {
        this.SendEvent( "monster_purchase", {currency_name, value, monster_id, planet_id, monster_rank});
    }

    SendPaymentEvent(inapp_id, currency, price, transaction_id) {
        this.SendEvent("payment_succeed", {inapp_id, currency, price, transaction_id});
    }

    SendMissionEvent(mission_id, mission_time, reward) {
        this.SendEvent("missions", {mission_id, mission_time, reward});
    }

    SendSlotSpinEvent(spin_currency, currency_value, reward, reward_value) {
        this.SendEvent( "slot_spin", {spin_currency, currency_value, reward, reward_value});
    }

    SendEvent(name, parameters) {
        console.log("ANALYTICS:", name, parameters);
    }
}
